import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import MainFont from 'ui/typography/mainFont';
import {
  AddIconWrapper,
  ButtonSave,
  DetailsTitle,
  DetailsWrapper,
  ExternalGridContainer,
  GridContainer
} from './style';
import theme from 'ui/theme';
import { FormInput, Icon } from 'ui/atoms';

import {
  leadDetailFieldsReadonly,
  IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER,
  isReadOnly
} from 'const';
import { MODAL_OPEN, SET_CONFIRMED } from 'redux/slices/modals';
import { UPDATE_LEAD_DETAIL } from 'redux/sagas/actions/leadDetail';
import DeletePreferenceModal from 'ui/components/Modals/DeletePreferenceModal';
import usePrevious from 'hooks/usePrevious';
import { SpinnerIcon } from 'ui/atoms/Table/style';
import spinnerIconBlue from 'ui/assets/img/spinner-icon-blue.png';

const DetailSectionProductPreference = ({
  leadDetailData,
  updateLeadDetail,
  leadStatus,
  role,
  userEmail,
  creatorEmail,
  leadType,
  isSaveEnabled,
  openConfirmModal,
  isLoadingUpdate,
  updatingSection
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState('');
  const [newNumberOfProducts, setNewNumberOfProducts] = useState([]);
  const previousProducts = usePrevious(newNumberOfProducts?.length || 0);
  const [updatedValuesArray, setUpdatedValuesArray] = useState([]);
  const [originalValues, setOriginalValues] = useState([]);
  const [showSave, setShowSave] = useState(false);

  useEffect(() => {
    if (newNumberOfProducts.length !== 0) {
      if (newNumberOfProducts.length > previousProducts) {
        setUpdatedValuesArray([
          ...updatedValuesArray,
          newNumberOfProducts[newNumberOfProducts.length - 1]
        ]);
      }
    }
    if (previousProducts > newNumberOfProducts?.length) {
      setUpdatedValuesArray([
        ...updatedValuesArray.slice(0, originalValues.length),
        ...newNumberOfProducts
      ]);
    }
  }, [
    newNumberOfProducts,
    originalValues.length,
    previousProducts,
    updatedValuesArray
  ]);

  useEffect(() => {
    if (leadDetailData?.innerData) {
      let data = '';
      let dataArray = [];
      const { innerData } = leadDetailData;
      if (innerData && Array.isArray(innerData)) {
        innerData.forEach(item =>
          item?.forEach(innerItem => {
            data = `${data.length !== 0 ? `${data};` : ''}${innerItem.value}`;
            dataArray = [...dataArray, innerItem.value];
          })
        );
      }
      setOriginalValues([...dataArray]);
      setUpdatedValuesArray([...dataArray]);
    }
  }, [leadDetailData]);

  useEffect(() => {
    if (
      updatedValuesArray?.length !== 0 &&
      originalValues &&
      ((newNumberOfProducts?.length !== 0 &&
        newNumberOfProducts.length !== originalValues.length) ||
        JSON.stringify(updatedValuesArray) !== JSON.stringify(originalValues))
    ) {
      setShowSave(true);
      isSaveEnabled(true);
    } else {
      setShowSave(false);
      isSaveEnabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newNumberOfProducts.length, originalValues, updatedValuesArray]);

  const loadNewProducts = () => {
    return newNumberOfProducts.map((newProduct, i) => (
      <div
        onMouseMove={() =>
          setSelected(`${t('product_preferences_placeholder')}${i}`)
        }
        onMouseLeave={() => {
          setSelected('');
        }}
      >
        <FormInput
          type="dropdown"
          label={t('product_preferences_placeholder')}
          labelFromBe="Product_of_Interest__c"
          readonly={false}
          key={i}
          value={
            newProduct &&
            !newProduct.includes(IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER)
              ? newProduct
              : '-'
          }
          isEditing={selected === `${t('product_preferences_placeholder')}${i}`}
          visible
          isLeadDetail
          arrayData={[
            { value: 'Prospect_vente borne et installation non effectuée', label: t('Prospect_vente borne et installation non effectuée') },
            { value: 'Client_vente borne et installation effectuée via bon de commande', label: t('Client_vente borne et installation effectuée via bon de commande') }
          ]}
          isNewValue
          //isDeletable={leadDetailData.title === 'product_preferences'}
          onChange={e => {
            if (e !== '-' && e?.value && e?.value !== '-') {
              const index = updatedValuesArray.findIndex(
                item =>
                  item === `${IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER}${i}`
              );
              const tmp = [...updatedValuesArray];
              tmp[index] = e?.value || e;
              const tmp2 = [...newNumberOfProducts];
              tmp2[i] = e?.value || e;
              setUpdatedValuesArray([...tmp]);
              setNewNumberOfProducts([...tmp2]);
            }
          }}
          onDeleteClick={() =>
            openConfirmModal({
              confirmDelete: () => {
                const tmp = [...newNumberOfProducts];
                tmp.splice(i, 1);
                setNewNumberOfProducts([
                  ...tmp.map((item, index) => {
                    if (
                      item.includes(IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER)
                    ) {
                      return `${IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER}${index}`;
                    } else {
                      return item;
                    }
                  })
                ]);
              }
            })
          }
        />
      </div>
    ));
  };

  return (
    <DetailsWrapper>
      <DetailsTitle>
        <MainFont type="4" configuration={{ fontSize: 16, lineHeight: '1.5' }}>
          {t(leadDetailData.title)}
        </MainFont>
        {showSave ? (
          isLoadingUpdate && updatingSection === leadDetailData.title ? (
            <ButtonSave
              onClick={e => {
                e.preventDefault();
              }}
            >
              <SpinnerIcon
                icon={spinnerIconBlue}
                marginRight={11}
                customSize={16}
              />
              {t('loading')}
            </ButtonSave>
          ) : (
            <ButtonSave
              onClick={() => {
                updateLeadDetail({
                  dataSectionTitle: leadDetailData.title,
                  data: updatedValuesArray
                });
              }}
            >
              <Icon
                type="icon-save"
                size={16}
                color={theme().colors.mainBlue}
              />
              {t('save_updates')}
            </ButtonSave>
          )
        ) : null}
      </DetailsTitle>
      <ExternalGridContainer>
        {leadDetailData?.innerData?.map((singleRow, key) => {
          if (singleRow && Array.isArray(singleRow)) {
            return (
              <GridContainer key={key} productPreferences>
                {singleRow?.map((element, i) => {
                  return (
                    <React.Fragment key={i}>
                      <div
                        onMouseMove={() =>
                          setSelected(element.labelForProducts)
                        }
                        onMouseLeave={() => {
                          setSelected('');
                        }}
                      >
                        <FormInput
                          type="dropdown"
                          label={element.label}
                          labelFromBe={element.labelFromBe}
                          readonly={
                            isReadOnly(
                              false,
                              role,
                              creatorEmail,
                              userEmail,
                              leadStatus
                            ) ||
                            leadDetailFieldsReadonly[leadType].includes(
                              element.label
                            ) ||
                            leadDetailData.title === 'lead_created_by'
                          }
                          key={key}
                          value={element.value}
                          isEditing={
                            !isReadOnly(
                              false,
                              role,
                              creatorEmail,
                              userEmail,
                              leadStatus
                            )
                              ? selected === element.labelForProducts
                              : null
                          }
                          visible
                          isLeadDetail
                          isPreference
                          arrayData={[
                            { value: 'Prospect_vente borne et installation non effectuée', label: t('Prospect_vente borne et installation non effectuée') },
                            { value: 'Client_vente borne et installation effectuée via bon de commande', label: t('Client_vente borne et installation effectuée via bon de commande') }         
                          ]}
                          handleDeletePreference={elementToDelete => {
                            const tmp = [...updatedValuesArray];
                            tmp.splice(i, 1);
                            updateLeadDetail({
                              dataSectionTitle: leadDetailData.title,
                              data: tmp
                            });
                          }}
                          onChange={e => {
                            if (e !== '-' && e?.value && e?.value !== '-') {
                              const replaceArray = [...updatedValuesArray];
                              replaceArray[i] = e?.value || e;
                              setUpdatedValuesArray([...replaceArray]);
                            }
                          }}
                          isDeletable={
                            leadDetailData.title === 'product_preferences'
                          }
                          onDeleteClick={() =>
                            openConfirmModal({
                              confirmDelete: () => {
                                const tmp = [...updatedValuesArray];
                                tmp.splice(i, 1);
                                updateLeadDetail({
                                  dataSectionTitle: leadDetailData.title,
                                  data: tmp
                                });
                              }
                            })
                          }
                        />
                      </div>
                      {!isReadOnly(
                        false,
                        role,
                        creatorEmail,
                        userEmail,
                        leadStatus
                      ) &&
                      i + newNumberOfProducts.length ===
                        leadDetailData.innerData?.[0].length -
                          1 +
                          newNumberOfProducts.length ? (
                        <>
                          {loadNewProducts()}
                          <AddIconWrapper
                            onClick={() => {
                              setNewNumberOfProducts([
                                ...newNumberOfProducts,
                                `${IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER}${newNumberOfProducts.length}`
                              ]);
                            }}
                          >
                            <Icon
                              type="icon-close"
                              size="12"
                              color={theme().colors.statusGreen}
                              rotate={45}
                            />
                          </AddIconWrapper>
                        </>
                      ) : null}
                    </React.Fragment>
                  );
                })}
              </GridContainer>
            );
          } else {
            if (
              !isReadOnly(false, role, creatorEmail, userEmail, leadStatus) &&
              leadDetailData.innerData?.[0] === undefined &&
              leadDetailData.title === 'product_preferences'
            ) {
              return (
                <GridContainer key={key} productPreferences>
                  {loadNewProducts(leadDetailData)}
                  <AddIconWrapper
                    onClick={() => {
                      setNewNumberOfProducts([
                        ...newNumberOfProducts,
                        `${IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER}${newNumberOfProducts.length}`
                      ]);
                    }}
                  >
                    <Icon
                      type="icon-close"
                      size="12"
                      color={theme().colors.statusGreen}
                      rotate={45}
                    />
                  </AddIconWrapper>
                </GridContainer>
              );
            }
          }
          return <></>;
        })}
        <DeletePreferenceModal />
      </ExternalGridContainer>
    </DetailsWrapper>
  );
};

DetailSectionProductPreference.propTypes = {
  leadDetailData: PropTypes.object,
  leadStatus: PropTypes.string,
  role: PropTypes.string,
  userEmail: PropTypes.string,
  creatorEmail: PropTypes.string,
  isSaveEnabled: PropTypes.func,
  updateLeadDetail: PropTypes.func,
  openConfirmModal: PropTypes.func,
  isLoadingUpdate: PropTypes.bool,
  updatingSection: PropTypes.string
};

export default connect(
  state => ({
    role: state?.authentication?.accountInfo?.role,
    userEmail: state?.authentication?.accountInfo?.email,
    isLoadingUpdate: state?.leadDetail?.isLoadingUpdate,
    updatingSection: state?.leadDetail?.updatingSection
  }),
  dispatch => ({
    pushUrl: url => dispatch(push(url)),
    setConfirm: payload => dispatch(SET_CONFIRMED(payload)),

    updateLeadDetail: ({ dataSectionTitle, data }) =>
      dispatch({
        type: UPDATE_LEAD_DETAIL._REQUEST,
        payload: { dataSectionTitle, data }
      }),
    openConfirmModal: payload =>
      dispatch(MODAL_OPEN({ id: 'DeletePreference', payload }))
  })
)(DetailSectionProductPreference);
